import { Navigate, RouteObject } from "react-router";

import MaterialHandlingPage from "./pages/MaterialHandlingPage";
import { ProcedureUpdates } from "@/features/task";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";
import { Translate } from "@/app/application/Translate";


export const materialHandlingRoutes: RouteObject = {
	path: "materialhandling/*",
	element: (
		<Sentry.ErrorBoundary
			fallback={({ error, componentStack, resetError }) => (
				<PageError
					error={error}
					componentStack={componentStack}
					reset={resetError}
				/>
			)}
		>
			<MaterialHandlingPage />
		</Sentry.ErrorBoundary>
	),
	children: [
		{
			index: true,
			element: <Navigate to="mypage" replace />,
		},
		{
			index: true,
			lazy: async () => {
				const { MaterialHandlingMyPage } =
					await import("./pages/MaterialHandlingList");
				return { Component: MaterialHandlingMyPage };
			},
		},
		{
			path: "mypage",
			lazy: async () => {
				const { MaterialHandlingMyPage } =
					await import("./pages/MaterialHandlingList");
				return { Component: MaterialHandlingMyPage };
			},
		},
		{
			path: "list",
			lazy: async () => {
				const { ViewMaterialHandlingList } =
					await import("./pages/MaterialHandlingList");
				return { Component: ViewMaterialHandlingList };
			},
		},
		{
			path: ":id/*",
			children: [
				{
					path: "edit",
					lazy: async () => {
						const { EditMaterialHandling } =
							await import("./pages/EditMaterialHandling");
						return { Component: EditMaterialHandling };
					},
				},
				{
					path: "editv2",
					lazy: async () => {
						const { EditMaterialHandling } =
							await import("./pages/EditMaterialHandling");
						return { Component: EditMaterialHandling };
					},
				},
				{
					path: "import",
					lazy: async () => {
						const { CreateMaterialHandling } =
							await import("./pages/CreateMaterialHandling");
						return {
							Component: () => <CreateMaterialHandling importMode={true} />,
						};
					},
				},
			],
		},
		{
			path: "view/*",
			children: [
				{
					path: ":id",
					lazy: async () => {
						const { ViewMaterialHandling } =
							await import("./pages/ViewMaterialHandling");
						return { Component: ViewMaterialHandling };
					},
				},
			],
		},
		{
			path: "tagid/:tagid",
			lazy: async () => {
				const { ViewMaterialHandling } =
					await import("./pages/ViewMaterialHandling");
				return { Component: ViewMaterialHandling };
			},
		},
		{
			path: "create/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { CreateMaterialHandling } =
							await import("./pages/CreateMaterialHandling");
						return { Component: CreateMaterialHandling };
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { CreateMaterialHandling } =
							await import("./pages/CreateMaterialHandling");
						return { Component: CreateMaterialHandling };
					},
				},
			],
		},
		{
			path: "approval/*",
			children: [
				{
					path: "pending",
					lazy: async () => {
						const { MaterialHandlingWaitingForApproval } =
							await import("./pages/MaterialHandlingWaitingForApproval");
						return { Component: MaterialHandlingWaitingForApproval };
					},
				},
				{
					path: "approve/:id/tag/:tagid",
					lazy: async () => {
						const { MaterialHandlingApproveUpdate } =
							await import("./pages/MaterialHandlingApproveUpdate");
						return { Component: MaterialHandlingApproveUpdate };
					},
				},
			],
		},
		{
			path: "settings",
			lazy: async () => {
				const { MaterialHandlingSettingsPage } =
					await import("@/app/application/admin-menu/settings/MaterialHandlingSettingsPage");
				return { Component: MaterialHandlingSettingsPage };
			},
		},
		{
			path: "save/:id",
			lazy: async () => {
				const { CompleteMaterialHandling } =
					await import("./pages/CompleteMaterialHandling");
				return { Component: CompleteMaterialHandling };
			},
		},
		{
			path: "archive/*",
			children: [
				{
					index: true,
					Component: () => (
						<h1>
							<Translate String="Auto.Features.MaterialHandling.Routes.L168C11.DashboardForMaterialHandlingArchiveIs">Dashboard for Material handling archive is under construction</Translate>
						</h1>
					),
				},
				{
					path: ":id",
					lazy: async () => {
						const { MaterialHandlingArchive } =
							await import("./pages/MaterialHandlingArchive");
						return { Component: MaterialHandlingArchive };
					},
				},
			],
		},
		{
			path: "updates/newImprov",
			element: <ProcedureUpdates page="newImprov" hasMaterialHandling={true} />,
		},
		{
			path: "updates/myImprov",
			element: <ProcedureUpdates page="myImprov" hasMaterialHandling={true} />,
		},
		{
			path: "updates/verified",
			element: <ProcedureUpdates page="verified" hasMaterialHandling={true} />,
		},
		{
			path: "procedureUpdates/declined",
			element: <ProcedureUpdates page="declined" hasMaterialHandling={true} />,
		},
	],
};
